<script setup lang="ts">
import { computed } from 'vue';

import { ButtonTextTheme } from '@/shared/components/UI/Buttons/ButtonText.vue';
import ErrorScreen from '@/shared/components/UI/ErrorScreen.vue';
import Modal from '@/shared/components/UI/Modal.vue';

const { active, theme = 'primary' } = defineProps<{
  active: boolean;
  errorMessage: string;
  theme?: ButtonTextTheme;
}>();

const emit = defineEmits(['update:active']);
const propModel = computed({
  get: () => active,
  set: (value) => {
    emit('update:active', value);
  }
});
</script>

<template>
  <Modal v-model:active="propModel" size="md">
    <ErrorScreen
      :theme="theme"
      :error="errorMessage"
      :overflow-character="true"
      @close="propModel = false"
    />
  </Modal>
</template>
